/**
 * Checks whether the current browser supports a set of features.
 *
 * @param fills
 * @returns {boolean}
 */
export function browserSupportsFeatures(fills) {
  fills = fills || [
    'IntersectionObserver',
    'Promise',
    'CustomEvent',
    'Element.prototype.classList',
    'Element.prototype.closest'
  ];
  var unsupportedFills = [];

  for (var i = 0; i < fills.length; i++) {
    var fill = fills[i];
    var parts = fill.split('.'); // i.e. ['Array', 'prototype', 'includes']

    var type = parts[0];
    var prototype = parts[1] === 'prototype';
    var method = parts[2];

    // Check for special test cases, otherwise use regular reduce function against window.
    var isSupported = false;

    switch (type) {
      case 'Intl':
        isSupported = window[type];
        break;

      case 'Element':
        isSupported = 'Element' in window;

        if (prototype && isSupported) {
          isSupported = method in Element.prototype;
        }

        break;

      default:
        isSupported = parts.reduce(function(key, value) {
          return key[value];
        }, window);
    }

    if (!isSupported) {
      unsupportedFills.push(fill);
    }
  }

  return unsupportedFills.length === 0;
}

/**
 * Loads a JavaScript file into the head of the site.
 * @link https://philipwalton.com/articles/loading-polyfills-only-when-needed/
 * @param src
 * @param done
 */
export function loadScript(src, done) {
  var js = document.createElement('script');
  js.src = src;

  js.onload = function() {
    done();
  };

  js.onerror = function() {
    done(new Error('Failed to load script ' + src));
  };

  document.head.appendChild(js);
}
